import React from 'react';
import { useSelector } from 'react-redux';
import URL from 'url-parse';

import { select } from '@swf/core/store';

import RedirectForm from './RedirectForm/RedirectForm';

interface Props {
  returnModal: string;
  values: object;
}

const MitIdRedirect: React.FC<Props> = ({ values, returnModal }) => {
  const href = useSelector(select.location.getHref);
  const returnUrl = new URL(href, true);
  returnUrl.set('query', { modal: returnModal });

  return <RedirectForm context={{ returnUrl: returnUrl.toString(), ...values }} />;
};

export default MitIdRedirect;
